// extracted by mini-css-extract-plugin
export default {"root":"PushNotificationsGate_root__p79yZ"};